import ChatIcon from "@styles/all-images/icons/ChatIconBlue.svg";
import DocumentIcon from "@styles/all-images/icons/document-icon-big.svg";
// import UserIcon from "@styles/all-images/icons/user-icon.svg";
// import StaffIcon from "@styles/all-images/icons/staff-icon.svg";
// import BlitzIcon from "@styles/all-images/icons/blitz-icon.svg";
import NotificationIconBig from "@styles/all-images/icons/notification-icon-big.svg";
import CheckIconBig from "@styles/all-images/icons/check-icon-big.svg";

export enum NotificationType {
  T4UploadDocument = 1,
  T4ReUploadDocument = 2,
  T3ApproveDocument = 3,
  T3RejectDocument = 4,
  IMDocumentReceived = 5,
  IMDocumentStatus = 6,
  TSDocumentReceived = 7,
  TSDocumentStatus = 8,
  BlitzOnboardingStatus = 9,
  UserOnboardingStatus = 10,
  NewUserRegistered = 11,
  StaffOnboarded = 12,
  ChatNotification = 13,
}

export const NotificationTypeText: Record<NotificationType, string> = {
  [NotificationType.T4UploadDocument]: "T4 Upload Document",
  [NotificationType.T4ReUploadDocument]: "T4 ReUpload Document",
  [NotificationType.T3ApproveDocument]: "T3 Approve Document",
  [NotificationType.T3RejectDocument]: "T3 Reject Document",
  [NotificationType.IMDocumentReceived]: "IM Document Received",
  [NotificationType.IMDocumentStatus]: "IM Document Status",
  [NotificationType.TSDocumentReceived]: "TS Document Received",
  [NotificationType.TSDocumentStatus]: "TS Document Status",
  [NotificationType.BlitzOnboardingStatus]: "Blitz Onboarding Status",
  [NotificationType.UserOnboardingStatus]: "User Onboarding Status",
  [NotificationType.NewUserRegistered]: "New User Registered",
  [NotificationType.StaffOnboarded]: "Staff Onboarded",
  [NotificationType.ChatNotification]: "Chat Notification",
};

export const NotificationTypeIcon: Record<NotificationType, string> = {
  [NotificationType.T4UploadDocument]: DocumentIcon,
  [NotificationType.T4ReUploadDocument]: DocumentIcon,
  [NotificationType.T3ApproveDocument]: CheckIconBig,
  [NotificationType.T3RejectDocument]: CheckIconBig,
  [NotificationType.IMDocumentReceived]: DocumentIcon,
  [NotificationType.IMDocumentStatus]: CheckIconBig,
  [NotificationType.TSDocumentReceived]: DocumentIcon,
  [NotificationType.TSDocumentStatus]: CheckIconBig,
  [NotificationType.BlitzOnboardingStatus]: NotificationIconBig,
  [NotificationType.UserOnboardingStatus]: NotificationIconBig,
  [NotificationType.NewUserRegistered]: NotificationIconBig,
  [NotificationType.StaffOnboarded]: NotificationIconBig,
  [NotificationType.ChatNotification]: ChatIcon,
};

export const NotificationTypeUrl: Record<NotificationType, string> = {
  [NotificationType.T4UploadDocument]:
    "/t3/view-onboarding-documents/:id?activeTab=0&activeFinOB=0&from=/document/to-be-approved",
  [NotificationType.T4ReUploadDocument]:
    "/t4/view-onboarding-document/view/:id",
  [NotificationType.T3ApproveDocument]:
    "/t4/view-onboarding-documents?activeTab=:tab&activeFinOB=:sequence&from=/notification",
  [NotificationType.T3RejectDocument]:
    "/t4/view-onboarding-documents?activeTab=:tab&activeFinOB=:sequence&from=/notification",
  [NotificationType.IMDocumentReceived]:
    "/view-im-ts-document/:id?type=im&history=false",
  [NotificationType.IMDocumentStatus]:
    "/view-im-ts-document/:id?type=im&history=false",
  [NotificationType.TSDocumentReceived]:
    "/view-im-ts-document/:id?type=ts&history=false",
  [NotificationType.TSDocumentStatus]:
    "/view-im-ts-document/:id?type=ts&history=false",
  [NotificationType.BlitzOnboardingStatus]: "/dashboard",
  [NotificationType.UserOnboardingStatus]: "/dashboard",
  [NotificationType.NewUserRegistered]: "/user-management/onboardedUsers",
  [NotificationType.StaffOnboarded]: "/staff-management",
  [NotificationType.ChatNotification]: "/live-chat",
};
